import React, { lazy, Suspense } from "react";
import "./App.css";
import { Routes, Route } from "react-router-dom";
import LoginPage from "./pages/LoginPage";
import ProtectedRoute from "./routes/ProtectedRoute";

const DashboardPage = lazy(() => import("./pages/DashboardPage"));
const AdminLoginPage = lazy(() => import("./admin/pages/login/AdminLoginPage"));
const AdminLayout = lazy(() => import("./admin/components/layout/AdminLayout"));
const CandidateListPage = lazy(() => import("./admin/pages/candidates/CandidateListPage"));
const EmployeeListPage = lazy(() => import("./admin/pages/employees/EmployeeListPage"));
const MonitoringPage = lazy(() => import("./admin/pages/monitoring/MonitoringPage"));
const ResumeSetupPage = lazy(() => import("./pages/ResumeSetupPage"));


function App() {
  return (
    <Suspense fallback={<div className="app-route-loading">Loading...</div>}>
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              }
            /> 
      {/* Admin login */}
      <Route path="/admin" element={<AdminLoginPage />} />
      <Route path="/admin/login" element={<AdminLoginPage />} />

      {/* Admin dashboard */}
      <Route
        path="/admin/dashboard"
        element={
          <ProtectedRoute allowedRoles={["ADMIN", "SUPER_ADMIN"]}>
            <AdminLayout />
          </ProtectedRoute>
        }
      >
        {/* 👇 THESE MUST BE NESTED */}
        <Route index element={<h2>Welcome Admin</h2>} />
        <Route path="candidates" element={<CandidateListPage />} />
        <Route path="employees" element={<EmployeeListPage />} />
        <Route path="monitoring" element={<MonitoringPage />} />
      </Route>

      {/* Standalone resume setup workspace */}
      <Route
        path="/resume-setup"
        element={<ResumeSetupPage />}
      />

      </Routes>
    </Suspense>
  );
}

export default App;
